export enum ResourceType {
  protected,
  public,
}
